import React from 'react';
import { CheckCircle, AlertTriangle, AlertCircle, FileSpreadsheet } from 'lucide-react';
import { CustomModal, CustomButton } from '../../atoms';
import { formatImportError } from '@/shared/utils/importErrorFormatter';
import './ImportSummaryModal.css';

interface ImportSummaryModalProps {
    isOpen: boolean;
    onClose: () => void;
    successCount: number;
    failedCount: number;
    errors: string[];
    fileName?: string;
    title?: string;
}

export const ImportSummaryModal: React.FC<ImportSummaryModalProps> = ({
    isOpen,
    onClose,
    successCount,
    failedCount,
    errors,
    fileName,
    title = 'Import Results Summary'
}) => {
    const footer = (
        <div className="import-summary-modal-actions">
            <CustomButton
                variant="filled"
                color="primary"
                onClick={onClose}
            >
                Close
            </CustomButton>
        </div>
    );

    return (
        <CustomModal
            isOpen={isOpen}
            onClose={onClose}
            size="medium"
            title={title}
            footer={footer}
            className="import-summary-modal-wrapper"
        >
            <div className="import-summary-content">
                {fileName && (
                    <div className="import-summary-filename">
                        <FileSpreadsheet size={14} style={{ marginRight: '0.4rem', verticalAlign: 'middle', display: 'inline' }} />
                        {fileName}
                    </div>
                )}

                <div className="import-summary-stats">
                    <div className="import-summary-card import-summary-card--success">
                        <div className="import-summary-card-icon">
                            <CheckCircle size={22} />
                        </div>
                        <div className="import-summary-card-info">
                            <span className="import-summary-card-label">Succeeded</span>
                            <span className="import-summary-card-value">{successCount}</span>
                        </div>
                    </div>

                    <div className="import-summary-card import-summary-card--failed">
                        <div className="import-summary-card-icon">
                            <AlertTriangle size={22} />
                        </div>
                        <div className="import-summary-card-info">
                            <span className="import-summary-card-label">Failed</span>
                            <span className="import-summary-card-value">{failedCount}</span>
                        </div>
                    </div>
                </div>

                {errors && errors.length > 0 && (
                    <div className="import-summary-errors-section">
                        <h4 className="import-summary-errors-title">
                            Detailed Errors
                            <span className="import-summary-errors-badge">{errors.length}</span>
                        </h4>
                        <div className="import-summary-errors-list">
                            {errors.map((err, index) => (
                                <div key={index} className="import-summary-error-item">
                                    <AlertCircle size={16} className="import-summary-error-icon" />
                                    <span className="import-summary-error-text">
                                        {formatImportError(err)}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </CustomModal>
    );
};

export default ImportSummaryModal;
